/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// action
import { requestCommentWidget, createCommentingUnit, approveCommenting } from 'state/actions/commentingState/commentingStatus';
// component
import RequestCommentWidget from 'pages/dashboard/commenting/requestcommentwidget/requestcommentwidget';
import {displayModal} from "@insticator/insticator-ui";



/* ========== ~~~~~~~~~~ REQUEST COMMENT WIDGET : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ commentingState, sessionStatus }) => ({
    status: commentingState.commentingStatus.requestStatus,
    emailSentTo: commentingState.commentingStatus.commentEmailSentTo,
    userEmail: sessionStatus.userEmail,
    requestPending: commentingState.commentingStatus.requestPending,
    approving: commentingState.commentingStatus.approving,
    accountUUID: sessionStatus.accountUUID,
    userUUID: sessionStatus.userUUID,
    mockupGenerator: sessionStatus.mockupGenerator,
    siteUUID: sessionStatus.siteUUID,
    mocked: sessionStatus.mocked,
});

const mapDispatchToProps = dispatch => ({
    requestCommentWidget: (accountUUID, userEmail) => dispatch(requestCommentWidget(accountUUID, userEmail)),
    createCommentingUnit: (accountUUID, siteUUID) => dispatch(createCommentingUnit(accountUUID, siteUUID)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    approveCommenting: (accountUUID) => dispatch(approveCommenting(accountUUID))
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestCommentWidget));
